import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { userAssignmentCodes } from '../../api/services/user_assignment_codes'
import { UserCode } from '../../api/services/user_assignment_codes/types.ts'
import CodeDetails from '../../components/assignmentCodes/CodeDetails/CodeDetails.tsx'
import CodeQr from '../../components/assignmentCodes/CodeQR/CodeQr.tsx'
import SurveyAssignment from '../../components/assignmentCodes/SurveyAssignment'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Card from '../../components/common/Card/Card.tsx'
import PatientProfiles from '../../components/patientProfiles/PatientProfiles.tsx'
import { useAuth } from '../../context/auth'
import useSubAccountDetails from '../../hooks/useSubAccountDetails.ts'
import { isUserExistsInGroup } from '../../utils/userRights.ts'

const AssignmentCodeDetails = () => {
  const { assignmentCodeId } = useParams<{ assignmentCodeId: string }>()
  const { state } = useAuth()
  const { subAccount } = useSubAccountDetails()

  const isMainUser = isUserExistsInGroup(state.groups, 'dd_panel_main_users')
  const navigate = useNavigate()
  const location = useLocation()
  const mainCodeId: number = location.state?.mainCodeId

  useEffect(() => {
    if (mainCodeId === undefined || assignmentCodeId === undefined) {
      navigate('/application/assignment-codes')
    }
  }, [mainCodeId, assignmentCodeId])

  const [code, setCode] = useState<UserCode | null>(null)
  const [surveyEnabled, setSurveyEnabled] = useState(false)
  const [, setIsPopupVisible] = useState(true)
  const [, setChangeStatus] = useState(false)

  useEffect(() => {
    const isEnabled = subAccount?.surveys_enabled ?? isMainUser
    if (isEnabled) setSurveyEnabled(isEnabled)
  }, [subAccount, state.groups])

  const fetchData = async () => {
    const data = await userAssignmentCodes.getCodeDetails(
      Number(assignmentCodeId)
    )
    setCode(data)
  }

  useEffect(() => {
    if (code === null) fetchData()
  }, [])

  return (
    <div>
      <Breadcrumbs
        pageName="Szczegóły kodu"
        breadcrumbs={[
          { label: 'Kody przypisujące', path: '/application/assignment-codes' },
          { label: 'Szczegóły kodu' }
        ]}
      />
      <div className="flex w-full 2xl:flex-row flex-col gap-4">
        <div className="flex w-full flex-col gap-4">
          {code && (
            <Card className="w-full">
              <Card.Body>
                <CodeDetails
                  codeObject={code}
                  setChangeStatus={setChangeStatus}
                  setIsPopupVisible={setIsPopupVisible}
                  mainCodeId={mainCodeId}
                />
              </Card.Body>
            </Card>
          )}

          {code && surveyEnabled && (
            <Card className="w-full">
              <Card.Body>
                <SurveyAssignment
                  mainCodeId={mainCodeId}
                  codeAssignmentID={code.id}
                  codeAssignment={code.code}
                  surveyTemplates={code.survey_templates}
                />
              </Card.Body>
            </Card>
          )}

          {code && (
            <Card className="w-full">
              <Card.Body>
                <PatientProfiles user_assignment_code={code.code} />
              </Card.Body>
            </Card>
          )}
        </div>

        {code && <CodeQr codeAssignment={code.code} />}
      </div>
    </div>
  )
}

export default AssignmentCodeDetails
